module.exports = __webpack_public_path__ + "static/media/Cacnea_gaussian2.b2ce3753.png";